var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarhire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;fill-rule:evenodd;}.b{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.5,16a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1ZM21,11v1H3V11ZM18.92,5.01A1.494,1.494,0,0,0,17.5,4H6.5A1.5,1.5,0,0,0,5.08,5.01L3,11v8a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V18H18v1a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V11ZM4,17.64a.5.5,0,0,1,.121.015l1,.25a.5.5,0,0,1,.379.485V19a.5.5,0,0,1-.5.5H4a.5.5,0,0,1-.5-.5v-.86A.5.5,0,0,1,4,17.64Zm16.485.379a.5.5,0,0,1,.015.121V19a.5.5,0,0,1-.5.5H19a.5.5,0,0,1-.5-.5v-.61a.5.5,0,0,1,.379-.485l1-.25A.5.5,0,0,1,20.485,18.019ZM6.5,16A1.5,1.5,0,1,1,8,14.5,1.5,1.5,0,0,1,6.5,16Zm11,0A1.5,1.5,0,1,1,19,14.5,1.5,1.5,0,0,1,17.5,16ZM2,9l1,2H2a1,1,0,0,1-1-1V9ZM23,9v1a1,1,0,0,1-1,1H21l1-2ZM18,5l1.5,5H4.5L6,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarhire);
export default __webpack_public_path__ + "static/media/carhire.c33d685362ab30d2f9865d1fa977a585.svg";
export { ForwardRef as ReactComponent };